import { Button } from 'themes/playful/components/Button/Button';
import { CtaBookNow } from 'themes/playful/components/CtaBookNow/CtaBookNow';
import { CtaViewMore } from 'themes/playful/components/CtaViewMore/CtaViewMore';
import { ReviewCarousel } from 'themes/playful/components/Reviews/ReviewCarousel';
import { TextureSection } from 'themes/playful/components/TextureSection/TextureSection';

import { useHomePage } from 'hooks/page/home/useHomePage';

import { GiftCardsSection } from './components/GitCards/GiftCardsSection';
import { ServiceList } from './components/ServiceList';

import s from './PlayfulHome.module.css';

export const PlayfulHome = () => {
  const {
    aboutLink,
    areGiftCardsEnabled,
    bookNowLinkUrl,
    currentReviewIndex,
    reviews,
    services,
    showNextReview,
    showPrevReview,
    showReviews,
  } = useHomePage();

  return (
    <main>
      <div className={s.bookButtonWrapper}>
        <Button to={bookNowLinkUrl} className={s.bookNowButton}>
          book now
        </Button>
      </div>
      {services.length > 0 && (
        <TextureSection title="Services">
          <ServiceList />
          <CtaViewMore to="/services" title="View all services" />
        </TextureSection>
      )}
      {showReviews ? (
        <ReviewCarousel
          aboutLink={aboutLink}
          currentReviewIndex={currentReviewIndex}
          onShowNextReview={showNextReview}
          onShowPrevReview={showPrevReview}
          reviews={reviews}
        />
      ) : null}
      {areGiftCardsEnabled && <GiftCardsSection />}
      <CtaBookNow />
    </main>
  );
};
